import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class WagerService extends BaseService {
    apiGetWagers(page, wagerStatus, date, token) {
        return this.post(API_URL + '/api/v2/wagers', {
            account: store.state.account,
            token: token,
            page: page,
            wagerStatus: wagerStatus,
            dateRange: date
        }).then(response => {
            if (response.data.status == 'success') {
                return response.data;
            }
        }).catch(err => {
            throw err.response.data;
        })
    }

    apiGetWagerDetails(token, reference) {
        return this.post(API_URL + '/api/v2/wager/details', {
            account: store.state.account,
            token: token,
            reference: reference
        }).then(response => {
            if (response.data.status == 'success') {
                return response.data.results;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new WagerService();
